import GenericSidebar from './GenericSidebar';

export default GenericSidebar;
